import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e6md0h54: FaireBrandEntity = {
  token: "b_e6md0h54",
  type: "brand",
  name: "Raaka Chocolate",
  avatarUrl:
    "https://cdn.faire.com/fastly/d775c3ca48752be14f2198be5a0f36725c20895a3e39719f7810f48ed40d2d72.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1580f7dee329fba4a0b1e5a726a85346f9e1df10441a6e8314863bfb3ff80193.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d775c3ca48752be14f2198be5a0f36725c20895a3e39719f7810f48ed40d2d72.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1580f7dee329fba4a0b1e5a726a85346f9e1df10441a6e8314863bfb3ff80193.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 320,
  isTopShop: true,
  isInsider: true,
  description:
    "We're devoted to making uncommonly delicious chocolate that captures the brighter, bolder and fruitier side of cacao. That's why we make every bar from scratch with unroasted cacao beans, sourced from growers we trust and admire. The unique flavor of our unroasted chocolate is part place, part process. We craft our bars in celebration of each cacao origin's unique character.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:04.959Z",
    importedBy: "entity-db-cli",
  },
};
